import { render, staticRenderFns } from "./AvailablePaymentMethods.vue?vue&type=template&id=45a1c5d2&scoped=true&"
import script from "./AvailablePaymentMethods.vue?vue&type=script&lang=js&"
export * from "./AvailablePaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./AvailablePaymentMethods.vue?vue&type=style&index=0&id=45a1c5d2&prod&scoped=true&lang=css&"
import style1 from "./AvailablePaymentMethods.vue?vue&type=style&index=1&id=45a1c5d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a1c5d2",
  null
  
)

export default component.exports